import { useIncludedRelationshipContext } from 'Views/Page/Contexts/IncludedRelationshipContext';
import DataContainer from 'Components/UI/DataContainer';
import React from 'react';
import ProposalInsightContent
  from 'Views/Page/Content/Templates/WhatIfProposalPreviewTemplate/MainContentPicker/MainContentForScenarioSelectionRedefined/ProposalInsightPicker/ProposalInsightContent';

const ProposalInsightContainer = () => {
  const { relationshipCollection, isInitializing } = useIncludedRelationshipContext();

  return (
    <DataContainer
      loading={isInitializing}
      component={ProposalInsightContent}
      componentProps={{
        collection: relationshipCollection,
      }}
    />
  );
};

export default ProposalInsightContainer;
